
import Vue from 'vue'

const locales = {keys(){return []}}
global['____33C1740____'] = true;
delete global['____33C1740____'];
global.__uniConfig = {"preloadRule":{"pages/assistSettled/assistSettled":{"network":"all","packages":["subPackages/chart"]},"pages/reAgent/reAgent":{"network":"all","packages":["subPackages/chart"]},"pages/paymentCode/paymentCode":{"network":"all","packages":["subPackages/chart"]},"pages/user/user":{"network":"all","packages":["subPackages/agent","subPackages/notice"]},"pages/orderShop/orderShop":{"network":"all","packages":["subPackages/goods"]},"pages/merOrderShop/merOrderShop":{"network":"all","packages":["subPackages/goods"]}},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"派思森","navigationBarBackgroundColor":"#ffffff","backgroundColor":"#F8F8F8"},"uniIdRouter":{},"tabBar":{"color":"#000","selectedColor":"#083a77","borderStyle":"black","backgroundColor":"#f7f7f7","list":[{"text":"首页","pagePath":"pages/index/index","iconPath":"static/tabar/index.png","selectedIconPath":"static/tabar/index-active.png","redDot":false,"badge":""},{"text":"在线商城","pagePath":"pages/shop/shop","iconPath":"static/tabar/shop.png","selectedIconPath":"static/tabar/shop-active.png","redDot":false,"badge":""},{"text":"个人中心","pagePath":"pages/user/user","iconPath":"static/tabar/user.png","selectedIconPath":"static/tabar/user-active.png","redDot":false,"badge":""}]}};
global.__uniConfig.compilerVersion = '4.76';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__33C1740';
global.__uniConfig.appName = 'pss_uni';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"MDOBZ-JTI3L-ODLPU-M5442-EM5P2-7CF3Q"}}};
global.__uniConfig.qqMapKey = "MDOBZ-JTI3L-ODLPU-M5442-EM5P2-7CF3Q";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchant-merchant', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchant/merchant"+'.vue')), 'pages-merchant-merchant'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/user/user"+'.vue')), 'pages-user-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/order/order"+'.vue')), 'pages-order-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-editUserInfo-editUserInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/user/editUserInfo/editUserInfo"+'.vue')), 'pages-user-editUserInfo-editUserInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-bindPhone-bindPhone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/user/bindPhone/bindPhone"+'.vue')), 'pages-user-bindPhone-bindPhone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-aboutAs-aboutAs', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/aboutAs/aboutAs"+'.vue')), 'pages-aboutAs-aboutAs'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-agreement-argument', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/agreement/argument"+'.vue')), 'pages-agreement-argument'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-register-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/register/register"+'.vue')), 'pages-register-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantDetail-merchantDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantDetail/merchantDetail"+'.vue')), 'pages-merchantDetail-merchantDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pointsList-pointsList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/pointsList/pointsList"+'.vue')), 'pages-pointsList-pointsList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantAgentJoin-merchantAgentJoin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantAgentJoin/merchantAgentJoin"+'.vue')), 'pages-merchantAgentJoin-merchantAgentJoin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantEdit-merchantEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantEdit/merchantEdit"+'.vue')), 'pages-merchantEdit-merchantEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-balanceList-balanceList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/balanceList/balanceList"+'.vue')), 'pages-balanceList-balanceList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-withdrawalBalance-withdrawalBalance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/withdrawalBalance/withdrawalBalance"+'.vue')), 'pages-withdrawalBalance-withdrawalBalance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-customer-customer', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/customer/customer"+'.vue')), 'pages-customer-customer'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-withdrawalIncome-withdrawalIncome', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/withdrawalIncome/withdrawalIncome"+'.vue')), 'pages-withdrawalIncome-withdrawalIncome'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-myCollect-myCollect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/myCollect/myCollect"+'.vue')), 'pages-myCollect-myCollect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-paymentCode-paymentCode', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/paymentCode/paymentCode"+'.vue')), 'pages-paymentCode-paymentCode'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-paymentAdd-paymentAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/paymentAdd/paymentAdd"+'.vue')), 'pages-paymentAdd-paymentAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-paymentList-paymentList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/paymentList/paymentList"+'.vue')), 'pages-paymentList-paymentList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantDividend-merchantDividend', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantDividend/merchantDividend"+'.vue')), 'pages-merchantDividend-merchantDividend'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-buyAgreement-buyAgreement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/buyAgreement/buyAgreement"+'.vue')), 'pages-buyAgreement-buyAgreement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay-pay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/pay/pay"+'.vue')), 'pages-pay-pay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-paySuccess-paySuccess', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/paySuccess/paySuccess"+'.vue')), 'pages-paySuccess-paySuccess'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsClass-goodsClass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodsClass/goodsClass"+'.vue')), 'pages-goodsClass-goodsClass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mealClass-mealClass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mealClass/mealClass"+'.vue')), 'pages-mealClass-mealClass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsClassAdd-goodsClassAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodsClassAdd/goodsClassAdd"+'.vue')), 'pages-goodsClassAdd-goodsClassAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mealClassAdd-mealClassAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mealClassAdd/mealClassAdd"+'.vue')), 'pages-mealClassAdd-mealClassAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodList-goodList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodList/goodList"+'.vue')), 'pages-goodList-goodList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mealList-mealList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mealList/mealList"+'.vue')), 'pages-mealList-mealList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodAdd-goodAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodAdd/goodAdd"+'.vue')), 'pages-goodAdd-goodAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mealAdd-mealAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mealAdd/mealAdd"+'.vue')), 'pages-mealAdd-mealAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-articleDetail-articleDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/articleDetail/articleDetail"+'.vue')), 'pages-articleDetail-articleDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-articleList-articleList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/articleList/articleList"+'.vue')), 'pages-articleList-articleList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-dividend-dividend', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/dividend/dividend"+'.vue')), 'pages-dividend-dividend'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantAgreement-merchantAgreement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantAgreement/merchantAgreement"+'.vue')), 'pages-merchantAgreement-merchantAgreement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assistSettled-assistSettled', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/assistSettled/assistSettled"+'.vue')), 'pages-assistSettled-assistSettled'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-patmentBind-patmentBind', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/patmentBind/patmentBind"+'.vue')), 'pages-patmentBind-patmentBind'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mdividend-mdividend', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mdividend/mdividend"+'.vue')), 'pages-mdividend-mdividend'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-incomeList-incomeList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/incomeList/incomeList"+'.vue')), 'pages-incomeList-incomeList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-fansList-fansList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/fansList/fansList"+'.vue')), 'pages-fansList-fansList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-inviteFans-inviteFans', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/inviteFans/inviteFans"+'.vue')), 'pages-inviteFans-inviteFans'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsCar-goodsCar', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodsCar/goodsCar"+'.vue')), 'pages-goodsCar-goodsCar'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsSettle-goodsSettle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodsSettle/goodsSettle"+'.vue')), 'pages-goodsSettle-goodsSettle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-orderShop-orderShop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/orderShop/orderShop"+'.vue')), 'pages-orderShop-orderShop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merOrderShop-merOrderShop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merOrderShop/merOrderShop"+'.vue')), 'pages-merOrderShop-merOrderShop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mzs-mzs', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mzs/mzs"+'.vue')), 'pages-mzs-mzs'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-addr-addr', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/addr/addr"+'.vue')), 'pages-addr-addr'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-addrEdit-addrEdit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/addrEdit/addrEdit"+'.vue')), 'pages-addrEdit-addrEdit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-partner-partner', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/partner/partner"+'.vue')), 'pages-partner-partner'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-xfList-xfList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/xfList/xfList"+'.vue')), 'pages-xfList-xfList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goodsDetail-goodsDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/goodsDetail/goodsDetail"+'.vue')), 'pages-goodsDetail-goodsDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-shop-shop', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/shop/shop"+'.vue')), 'pages-shop-shop'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-parent-parent', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/parent/parent"+'.vue')), 'pages-parent-parent'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pc-pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/pc/pc"+'.vue')), 'pages-pc-pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-evaluate-evaluate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/evaluate/evaluate"+'.vue')), 'pages-evaluate-evaluate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-sbList-sbList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/sbList/sbList"+'.vue')), 'pages-sbList-sbList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-sbAdd-sbAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/sbAdd/sbAdd"+'.vue')), 'pages-sbAdd-sbAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-reAgent-reAgent', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/reAgent/reAgent"+'.vue')), 'pages-reAgent-reAgent'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-orderCode-orderCode', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/orderCode/orderCode"+'.vue')), 'pages-orderCode-orderCode'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-orderCodeAdd-orderCodeAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/orderCodeAdd/orderCodeAdd"+'.vue')), 'pages-orderCodeAdd-orderCodeAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mealOrders-mealOrders', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/mealOrders/mealOrders"+'.vue')), 'pages-mealOrders-mealOrders'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-merchantSetting-merchantSetting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/merchantSetting/merchantSetting"+'.vue')), 'pages-merchantSetting-merchantSetting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-chainStore-chainStore', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/pages/chainStore/chainStore"+'.vue')), 'pages-chainStore-chainStore'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-chart-pages-merData-merData', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/chart/pages/merData/merData"+'.vue')), 'subPackages-chart-pages-merData-merData'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-chart-pages-reData-reData', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/chart/pages/reData/reData"+'.vue')), 'subPackages-chart-pages-reData-reData'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-chart-pages-reMerList-reMerList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/chart/pages/reMerList/reMerList"+'.vue')), 'subPackages-chart-pages-reMerList-reMerList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-chart-pages-paymentCodeData-paymentCodeData', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/chart/pages/paymentCodeData/paymentCodeData"+'.vue')), 'subPackages-chart-pages-paymentCodeData-paymentCodeData'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-chart-pages-paymentData-paymentData', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/chart/pages/paymentData/paymentData"+'.vue')), 'subPackages-chart-pages-paymentData-paymentData'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-agent-pages-softwareAdd-softwareAdd', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/agent/pages/softwareAdd/softwareAdd"+'.vue')), 'subPackages-agent-pages-softwareAdd-softwareAdd'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-agent-pages-softwareCore-softwareCore', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/agent/pages/softwareCore/softwareCore"+'.vue')), 'subPackages-agent-pages-softwareCore-softwareCore'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-agent-pages-softwareInventory-softwareInventory', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/agent/pages/softwareInventory/softwareInventory"+'.vue')), 'subPackages-agent-pages-softwareInventory-softwareInventory'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-goods-pages-orderShopDetail-orderShopDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/goods/pages/orderShopDetail/orderShopDetail"+'.vue')), 'subPackages-goods-pages-orderShopDetail-orderShopDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-goods-pages-merOrderShopDetail-merOrderShopDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/goods/pages/merOrderShopDetail/merOrderShopDetail"+'.vue')), 'subPackages-goods-pages-merOrderShopDetail-merOrderShopDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-scan-pages-orderMealList-orderMealList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/scan/pages/orderMealList/orderMealList"+'.vue')), 'subPackages-scan-pages-orderMealList-orderMealList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-scan-pages-mealSearch-mealSearch', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/scan/pages/mealSearch/mealSearch"+'.vue')), 'subPackages-scan-pages-mealSearch-mealSearch'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-scan-pages-myScanOrder-myScanOrder', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/scan/pages/myScanOrder/myScanOrder"+'.vue')), 'subPackages-scan-pages-myScanOrder-myScanOrder'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-scan-pages-orderPay-orderPay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/scan/pages/orderPay/orderPay"+'.vue')), 'subPackages-scan-pages-orderPay-orderPay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-notice-pages-noticeList-noticeList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/notice/pages/noticeList/noticeList"+'.vue')), 'subPackages-notice-pages-noticeList-noticeList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('subPackages-notice-pages-noticeDetail-noticeDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/project/pss_uni/subPackages/notice/pages/noticeDetail/noticeDetail"+'.vue')), 'subPackages-notice-pages-noticeDetail-noticeDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/merchant/merchant',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家"})
      },
      [
        createElement('pages-merchant-merchant', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchant-merchant',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchant/merchant',
  windowTop:44
}
},
{
path: '/pages/user/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-user-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-user-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/user',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/order/order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单中心"})
      },
      [
        createElement('pages-order-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order/order',
  windowTop:44
}
},
{
path: '/pages/user/editUserInfo/editUserInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员资料"})
      },
      [
        createElement('pages-user-editUserInfo-editUserInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-editUserInfo-editUserInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/editUserInfo/editUserInfo',
  windowTop:44
}
},
{
path: '/pages/user/bindPhone/bindPhone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机号"})
      },
      [
        createElement('pages-user-bindPhone-bindPhone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-bindPhone-bindPhone',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/bindPhone/bindPhone',
  windowTop:44
}
},
{
path: '/pages/aboutAs/aboutAs',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pages-aboutAs-aboutAs', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-aboutAs-aboutAs',
  isNVue:false,maxWidth:0,
  pagePath:'pages/aboutAs/aboutAs',
  windowTop:44
}
},
{
path: '/pages/agreement/argument',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"协议 "})
      },
      [
        createElement('pages-agreement-argument', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-agreement-argument',
  isNVue:false,maxWidth:0,
  pagePath:'pages/agreement/argument',
  windowTop:44
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:44
}
},
{
path: '/pages/register/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册"})
      },
      [
        createElement('pages-register-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-register-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/register/register',
  windowTop:44
}
},
{
path: '/pages/merchantDetail/merchantDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家详情"})
      },
      [
        createElement('pages-merchantDetail-merchantDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantDetail-merchantDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantDetail/merchantDetail',
  windowTop:44
}
},
{
path: '/pages/pointsList/pointsList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分记录"})
      },
      [
        createElement('pages-pointsList-pointsList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pointsList-pointsList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pointsList/pointsList',
  windowTop:44
}
},
{
path: '/pages/merchantAgentJoin/merchantAgentJoin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"协助申请入驻"})
      },
      [
        createElement('pages-merchantAgentJoin-merchantAgentJoin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantAgentJoin-merchantAgentJoin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantAgentJoin/merchantAgentJoin',
  windowTop:44
}
},
{
path: '/pages/merchantEdit/merchantEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家信息"})
      },
      [
        createElement('pages-merchantEdit-merchantEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantEdit-merchantEdit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantEdit/merchantEdit',
  windowTop:44
}
},
{
path: '/pages/balanceList/balanceList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的积分"})
      },
      [
        createElement('pages-balanceList-balanceList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-balanceList-balanceList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/balanceList/balanceList',
  windowTop:44
}
},
{
path: '/pages/withdrawalBalance/withdrawalBalance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分提现"})
      },
      [
        createElement('pages-withdrawalBalance-withdrawalBalance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-withdrawalBalance-withdrawalBalance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/withdrawalBalance/withdrawalBalance',
  windowTop:44
}
},
{
path: '/pages/customer/customer',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"联系客服"})
      },
      [
        createElement('pages-customer-customer', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-customer-customer',
  isNVue:false,maxWidth:0,
  pagePath:'pages/customer/customer',
  windowTop:44
}
},
{
path: '/pages/withdrawalIncome/withdrawalIncome',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金提现"})
      },
      [
        createElement('pages-withdrawalIncome-withdrawalIncome', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-withdrawalIncome-withdrawalIncome',
  isNVue:false,maxWidth:0,
  pagePath:'pages/withdrawalIncome/withdrawalIncome',
  windowTop:44
}
},
{
path: '/pages/myCollect/myCollect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的收藏"})
      },
      [
        createElement('pages-myCollect-myCollect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-myCollect-myCollect',
  isNVue:false,maxWidth:0,
  pagePath:'pages/myCollect/myCollect',
  windowTop:44
}
},
{
path: '/pages/paymentCode/paymentCode',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款码"})
      },
      [
        createElement('pages-paymentCode-paymentCode', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-paymentCode-paymentCode',
  isNVue:false,maxWidth:0,
  pagePath:'pages/paymentCode/paymentCode',
  windowTop:44
}
},
{
path: '/pages/paymentAdd/paymentAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-paymentAdd-paymentAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-paymentAdd-paymentAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/paymentAdd/paymentAdd',
  windowTop:44
}
},
{
path: '/pages/paymentList/paymentList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款记录"})
      },
      [
        createElement('pages-paymentList-paymentList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-paymentList-paymentList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/paymentList/paymentList',
  windowTop:44
}
},
{
path: '/pages/merchantDividend/merchantDividend',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"赞赏记录"})
      },
      [
        createElement('pages-merchantDividend-merchantDividend', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantDividend-merchantDividend',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantDividend/merchantDividend',
  windowTop:44
}
},
{
path: '/pages/buyAgreement/buyAgreement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户购买协议"})
      },
      [
        createElement('pages-buyAgreement-buyAgreement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-buyAgreement-buyAgreement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/buyAgreement/buyAgreement',
  windowTop:44
}
},
{
path: '/pages/pay/pay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付"})
      },
      [
        createElement('pages-pay-pay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay-pay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay/pay',
  windowTop:44
}
},
{
path: '/pages/paySuccess/paySuccess',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付结果"})
      },
      [
        createElement('pages-paySuccess-paySuccess', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-paySuccess-paySuccess',
  isNVue:false,maxWidth:0,
  pagePath:'pages/paySuccess/paySuccess',
  windowTop:44
}
},
{
path: '/pages/goodsClass/goodsClass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品分类"})
      },
      [
        createElement('pages-goodsClass-goodsClass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsClass-goodsClass',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodsClass/goodsClass',
  windowTop:44
}
},
{
path: '/pages/mealClass/mealClass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"点单分类"})
      },
      [
        createElement('pages-mealClass-mealClass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mealClass-mealClass',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mealClass/mealClass',
  windowTop:44
}
},
{
path: '/pages/goodsClassAdd/goodsClassAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增分类"})
      },
      [
        createElement('pages-goodsClassAdd-goodsClassAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsClassAdd-goodsClassAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodsClassAdd/goodsClassAdd',
  windowTop:44
}
},
{
path: '/pages/mealClassAdd/mealClassAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增分类"})
      },
      [
        createElement('pages-mealClassAdd-mealClassAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mealClassAdd-mealClassAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mealClassAdd/mealClassAdd',
  windowTop:44
}
},
{
path: '/pages/goodList/goodList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-goodList-goodList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodList-goodList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodList/goodList',
  windowTop:44
}
},
{
path: '/pages/mealList/mealList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"点单列表"})
      },
      [
        createElement('pages-mealList-mealList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mealList-mealList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mealList/mealList',
  windowTop:44
}
},
{
path: '/pages/goodAdd/goodAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增商品"})
      },
      [
        createElement('pages-goodAdd-goodAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodAdd-goodAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodAdd/goodAdd',
  windowTop:44
}
},
{
path: '/pages/mealAdd/mealAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增点单商品"})
      },
      [
        createElement('pages-mealAdd-mealAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mealAdd-mealAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mealAdd/mealAdd',
  windowTop:44
}
},
{
path: '/pages/articleDetail/articleDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"文章详情"})
      },
      [
        createElement('pages-articleDetail-articleDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-articleDetail-articleDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/articleDetail/articleDetail',
  windowTop:44
}
},
{
path: '/pages/articleList/articleList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"帮助中心"})
      },
      [
        createElement('pages-articleList-articleList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-articleList-articleList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/articleList/articleList',
  windowTop:44
}
},
{
path: '/pages/dividend/dividend',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消费赞赏记录"})
      },
      [
        createElement('pages-dividend-dividend', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-dividend-dividend',
  isNVue:false,maxWidth:0,
  pagePath:'pages/dividend/dividend',
  windowTop:44
}
},
{
path: '/pages/merchantAgreement/merchantAgreement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家入驻协议"})
      },
      [
        createElement('pages-merchantAgreement-merchantAgreement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantAgreement-merchantAgreement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantAgreement/merchantAgreement',
  windowTop:44
}
},
{
path: '/pages/assistSettled/assistSettled',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"协助入驻"})
      },
      [
        createElement('pages-assistSettled-assistSettled', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assistSettled-assistSettled',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assistSettled/assistSettled',
  windowTop:44
}
},
{
path: '/pages/patmentBind/patmentBind',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定收款码"})
      },
      [
        createElement('pages-patmentBind-patmentBind', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-patmentBind-patmentBind',
  isNVue:false,maxWidth:0,
  pagePath:'pages/patmentBind/patmentBind',
  windowTop:44
}
},
{
path: '/pages/mdividend/mdividend',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"赞赏排队"})
      },
      [
        createElement('pages-mdividend-mdividend', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mdividend-mdividend',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mdividend/mdividend',
  windowTop:44
}
},
{
path: '/pages/incomeList/incomeList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广交易记录"})
      },
      [
        createElement('pages-incomeList-incomeList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-incomeList-incomeList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/incomeList/incomeList',
  windowTop:44
}
},
{
path: '/pages/fansList/fansList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的好友"})
      },
      [
        createElement('pages-fansList-fansList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-fansList-fansList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/fansList/fansList',
  windowTop:44
}
},
{
path: '/pages/inviteFans/inviteFans',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"邀请粉丝"})
      },
      [
        createElement('pages-inviteFans-inviteFans', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-inviteFans-inviteFans',
  isNVue:false,maxWidth:0,
  pagePath:'pages/inviteFans/inviteFans',
  windowTop:44
}
},
{
path: '/pages/goodsCar/goodsCar',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-goodsCar-goodsCar', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsCar-goodsCar',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodsCar/goodsCar',
  windowTop:44
}
},
{
path: '/pages/goodsSettle/goodsSettle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单结算台"})
      },
      [
        createElement('pages-goodsSettle-goodsSettle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsSettle-goodsSettle',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodsSettle/goodsSettle',
  windowTop:44
}
},
{
path: '/pages/orderShop/orderShop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商城订单"})
      },
      [
        createElement('pages-orderShop-orderShop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-orderShop-orderShop',
  isNVue:false,maxWidth:0,
  pagePath:'pages/orderShop/orderShop',
  windowTop:44
}
},
{
path: '/pages/merOrderShop/merOrderShop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商城订单"})
      },
      [
        createElement('pages-merOrderShop-merOrderShop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merOrderShop-merOrderShop',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merOrderShop/merOrderShop',
  windowTop:44
}
},
{
path: '/pages/mzs/mzs',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款赞赏"})
      },
      [
        createElement('pages-mzs-mzs', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mzs-mzs',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mzs/mzs',
  windowTop:44
}
},
{
path: '/pages/addr/addr',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收货地址"})
      },
      [
        createElement('pages-addr-addr', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-addr-addr',
  isNVue:false,maxWidth:0,
  pagePath:'pages/addr/addr',
  windowTop:44
}
},
{
path: '/pages/addrEdit/addrEdit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"编辑地址"})
      },
      [
        createElement('pages-addrEdit-addrEdit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-addrEdit-addrEdit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/addrEdit/addrEdit',
  windowTop:44
}
},
{
path: '/pages/partner/partner',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请合伙人"})
      },
      [
        createElement('pages-partner-partner', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-partner-partner',
  isNVue:false,maxWidth:0,
  pagePath:'pages/partner/partner',
  windowTop:44
}
},
{
path: '/pages/xfList/xfList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消费金记录"})
      },
      [
        createElement('pages-xfList-xfList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-xfList-xfList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/xfList/xfList',
  windowTop:44
}
},
{
path: '/pages/goodsDetail/goodsDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品详情"})
      },
      [
        createElement('pages-goodsDetail-goodsDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goodsDetail-goodsDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goodsDetail/goodsDetail',
  windowTop:44
}
},
{
path: '/pages/shop/shop',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"在线商城"})
      },
      [
        createElement('pages-shop-shop', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-shop-shop',
  isNVue:false,maxWidth:0,
  pagePath:'pages/shop/shop',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/parent/parent',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的邀请人"})
      },
      [
        createElement('pages-parent-parent', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-parent-parent',
  isNVue:false,maxWidth:0,
  pagePath:'pages/parent/parent',
  windowTop:44
}
},
{
path: '/pages/pc/pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"电脑端"})
      },
      [
        createElement('pages-pc-pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pc-pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pc/pc',
  windowTop:44
}
},
{
path: '/pages/evaluate/evaluate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('pages-evaluate-evaluate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-evaluate-evaluate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/evaluate/evaluate',
  windowTop:44
}
},
{
path: '/pages/sbList/sbList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设备管理"})
      },
      [
        createElement('pages-sbList-sbList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-sbList-sbList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/sbList/sbList',
  windowTop:44
}
},
{
path: '/pages/sbAdd/sbAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增设备"})
      },
      [
        createElement('pages-sbAdd-sbAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-sbAdd-sbAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/sbAdd/sbAdd',
  windowTop:44
}
},
{
path: '/pages/reAgent/reAgent',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"区代列表"})
      },
      [
        createElement('pages-reAgent-reAgent', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-reAgent-reAgent',
  isNVue:false,maxWidth:0,
  pagePath:'pages/reAgent/reAgent',
  windowTop:44
}
},
{
path: '/pages/orderCode/orderCode',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"点单码"})
      },
      [
        createElement('pages-orderCode-orderCode', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-orderCode-orderCode',
  isNVue:false,maxWidth:0,
  pagePath:'pages/orderCode/orderCode',
  windowTop:44
}
},
{
path: '/pages/orderCodeAdd/orderCodeAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新增点单码"})
      },
      [
        createElement('pages-orderCodeAdd-orderCodeAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-orderCodeAdd-orderCodeAdd',
  isNVue:false,maxWidth:0,
  pagePath:'pages/orderCodeAdd/orderCodeAdd',
  windowTop:44
}
},
{
path: '/pages/mealOrders/mealOrders',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"点单订单"})
      },
      [
        createElement('pages-mealOrders-mealOrders', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mealOrders-mealOrders',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mealOrders/mealOrders',
  windowTop:44
}
},
{
path: '/pages/merchantSetting/merchantSetting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商家配置"})
      },
      [
        createElement('pages-merchantSetting-merchantSetting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-merchantSetting-merchantSetting',
  isNVue:false,maxWidth:0,
  pagePath:'pages/merchantSetting/merchantSetting',
  windowTop:44
}
},
{
path: '/pages/chainStore/chainStore',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的连锁"})
      },
      [
        createElement('pages-chainStore-chainStore', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-chainStore-chainStore',
  isNVue:false,maxWidth:0,
  pagePath:'pages/chainStore/chainStore',
  windowTop:44
}
},
{
path: '/subPackages/chart/pages/merData/merData',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"经营数据"})
      },
      [
        createElement('subPackages-chart-pages-merData-merData', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-chart-pages-merData-merData',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/chart/pages/merData/merData',
  windowTop:44
}
},
{
path: '/subPackages/chart/pages/reData/reData',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"区域数据"})
      },
      [
        createElement('subPackages-chart-pages-reData-reData', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-chart-pages-reData-reData',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/chart/pages/reData/reData',
  windowTop:44
}
},
{
path: '/subPackages/chart/pages/reMerList/reMerList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"区域店铺"})
      },
      [
        createElement('subPackages-chart-pages-reMerList-reMerList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-chart-pages-reMerList-reMerList',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/chart/pages/reMerList/reMerList',
  windowTop:44
}
},
{
path: '/subPackages/chart/pages/paymentCodeData/paymentCodeData',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款码统计"})
      },
      [
        createElement('subPackages-chart-pages-paymentCodeData-paymentCodeData', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-chart-pages-paymentCodeData-paymentCodeData',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/chart/pages/paymentCodeData/paymentCodeData',
  windowTop:44
}
},
{
path: '/subPackages/chart/pages/paymentData/paymentData',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收款统计"})
      },
      [
        createElement('subPackages-chart-pages-paymentData-paymentData', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-chart-pages-paymentData-paymentData',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/chart/pages/paymentData/paymentData',
  windowTop:44
}
},
{
path: '/subPackages/agent/pages/softwareAdd/softwareAdd',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"充值中心"})
      },
      [
        createElement('subPackages-agent-pages-softwareAdd-softwareAdd', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-agent-pages-softwareAdd-softwareAdd',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/agent/pages/softwareAdd/softwareAdd',
  windowTop:44
}
},
{
path: '/subPackages/agent/pages/softwareCore/softwareCore',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"软件中心"})
      },
      [
        createElement('subPackages-agent-pages-softwareCore-softwareCore', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-agent-pages-softwareCore-softwareCore',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/agent/pages/softwareCore/softwareCore',
  windowTop:44
}
},
{
path: '/subPackages/agent/pages/softwareInventory/softwareInventory',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"软件中心"})
      },
      [
        createElement('subPackages-agent-pages-softwareInventory-softwareInventory', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-agent-pages-softwareInventory-softwareInventory',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/agent/pages/softwareInventory/softwareInventory',
  windowTop:44
}
},
{
path: '/subPackages/goods/pages/orderShopDetail/orderShopDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('subPackages-goods-pages-orderShopDetail-orderShopDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-goods-pages-orderShopDetail-orderShopDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/goods/pages/orderShopDetail/orderShopDetail',
  windowTop:44
}
},
{
path: '/subPackages/goods/pages/merOrderShopDetail/merOrderShopDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('subPackages-goods-pages-merOrderShopDetail-merOrderShopDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-goods-pages-merOrderShopDetail-merOrderShopDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/goods/pages/merOrderShopDetail/merOrderShopDetail',
  windowTop:44
}
},
{
path: '/subPackages/scan/pages/orderMealList/orderMealList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"菜单"})
      },
      [
        createElement('subPackages-scan-pages-orderMealList-orderMealList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-scan-pages-orderMealList-orderMealList',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/scan/pages/orderMealList/orderMealList',
  windowTop:0
}
},
{
path: '/subPackages/scan/pages/mealSearch/mealSearch',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品搜索"})
      },
      [
        createElement('subPackages-scan-pages-mealSearch-mealSearch', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-scan-pages-mealSearch-mealSearch',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/scan/pages/mealSearch/mealSearch',
  windowTop:44
}
},
{
path: '/subPackages/scan/pages/myScanOrder/myScanOrder',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单"})
      },
      [
        createElement('subPackages-scan-pages-myScanOrder-myScanOrder', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-scan-pages-myScanOrder-myScanOrder',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/scan/pages/myScanOrder/myScanOrder',
  windowTop:44
}
},
{
path: '/subPackages/scan/pages/orderPay/orderPay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单支付"})
      },
      [
        createElement('subPackages-scan-pages-orderPay-orderPay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-scan-pages-orderPay-orderPay',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/scan/pages/orderPay/orderPay',
  windowTop:44
}
},
{
path: '/subPackages/notice/pages/noticeList/noticeList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告列表"})
      },
      [
        createElement('subPackages-notice-pages-noticeList-noticeList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-notice-pages-noticeList-noticeList',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/notice/pages/noticeList/noticeList',
  windowTop:44
}
},
{
path: '/subPackages/notice/pages/noticeDetail/noticeDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"公告详情"})
      },
      [
        createElement('subPackages-notice-pages-noticeDetail-noticeDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'subPackages-notice-pages-noticeDetail-noticeDetail',
  isNVue:false,maxWidth:0,
  pagePath:'subPackages/notice/pages/noticeDetail/noticeDetail',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
